module.exports = __webpack_public_path__ + "img/202602_03.18369394.png";